/**
 * /flightsearch was the legacy search page (src/pages/Search.jsx, removed
 * 2026-10-28). It priced a flight with no fare step from its search card, for
 * whichever travelers were in the form, and sent round trips to checkout with
 * the outbound and return cards added together. Its traffic was near zero; old
 * links now open the main search (/search) with the same trip.
 *
 * Legacy query names: origin, destination, departDate, returnDate, cabinClass,
 * adults, children, infants (lap infants, as on /search).
 */
import { readPassengerParams, writePassengerParams } from '@/utils/passengerTypes';

const DAY = /^\d{4}-\d{2}-\d{2}$/;

export function legacyFlightSearchPath(search = '') {
  const legacy = new URLSearchParams(search || '');
  const next = new URLSearchParams();
  const origin = legacy.get('origin');
  const destination = legacy.get('destination');
  const depart = legacy.get('departDate') || legacy.get('departureDate');
  const ret = legacy.get('returnDate');
  if (origin) next.set('origin', origin);
  if (destination) next.set('destination', destination);
  if (depart && DAY.test(depart)) next.set('departureDate', depart);
  if (ret && DAY.test(ret)) next.set('returnDate', ret);
  if (legacy.has('adults') || legacy.has('children') || legacy.has('infants') || legacy.has('infantsInSeat')) {
    writePassengerParams(next, readPassengerParams(legacy));
  }
  const cabin = legacy.get('cabinClass') || legacy.get('cabin');
  if (cabin) next.set('cabin', cabin);
  const query = next.toString();
  return query ? `/search?${query}` : '/search';
}
